export const makeUrl = (
  url: string,
  queryParams?: string[][] | Record<string, string> | string | URLSearchParams
) => {
  if (!queryParams) {
    return url;
  }

  const urlSearchParams = new URLSearchParams(queryParams);
  const separator = url.includes('?') ? '&' : '?';

  return `${url}${separator}${urlSearchParams}`.replace(/[?&]$/, '');
};
